// 职务字典
export const postDic = [
  {
    name: "院长",
    value: "1",
  },
  {
    name: "副院长",
    value: "2",
  },
  {
    name: "科室/部门主任",
    value: "3",
  },
  {
    name: "科室/部门副主任",
    value: "4",
  },
  {
    name: "普通医师",
    value: "5",
  },
  {
    name: "其他",
    value: "6",
  },
  {
    name: "书记",
    value: "7",
  },
  {
    name: "副书记",
    value: "8",
  },
];
// 性别字典
export const sexDic = [
  {
    name: "男",
    value: "0",
  },
  {
    name: "女",
    value: "1",
  },
];
// 证件字典
export const cardTypeDic = [
  {
    name: "居民身份证",
    value: "0",
  },
  {
    name: "其他",
    value: "1",
  },
];

// 所在中心字典

export const hospitalCenterDic = [
  {
    name: "肿瘤防治中心",
    value: "0",
  },
  {
    name: "慢病管理中心",
    value: "1",
  },
  {
    name: "微创介入中心",
    value: "2",
  },
  {
    name: "麻醉疼痛诊疗中心",
    value: "3",
  },
  {
    name: "重症监护中心",
    value: "4",
  },
  {
    name: "胸痛中心",
    value: "5",
  },
  {
    name: "卒中中心",
    value: "6",
  },
  {
    name: "创伤中心",
    value: "7",
  },
  {
    name: "危重孕产妇救治中心",
    value: "8",
  },
  {
    name: "危重儿童和新生儿救治中心",
    value: "9",
  },
  {
    name: "医学检验中心",
    value: "10",
  },
  {
    name: "医学影像中心",
    value: "11",
  },
  {
    name: "心电诊断中心",
    value: "12",
  },
  {
    name: "病理中心",
    value: "13",
  },
  {
    name: "消毒供应中心",
    value: "14",
  },
  {
    name: "医疗质控中心",
    value: "15",
  },
  {
    name: "人力资源中心",
    value: "16",
  },
  {
    name: "运营管理中心",
    value: "17",
  },
  {
    name: "医保管理中心",
    value: "18",
  },
  {
    name: "信息数据中心",
    value: "19",
  },
  {
    name: "其他",
    value: "20",
  },
];

// 职称字典
export const professionalTitleDic = [
  {
    name: "主任医师",
    value: "1",
  },
  {
    name: "副主任医师",
    value: "2",
  },
  {
    name: "主治医师",
    value: "3",
  },
  {
    name: "医师",
    value: "4",
  },
  {
    name: "医士",
    value: "5",
  },
  {
    name: "主任药师",
    value: "6",
  },
  {
    name: "副主任药师",
    value: "7",
  },
  {
    name: "主管药师",
    value: "8",
  },
  {
    name: "药师",
    value: "9",
  },
  {
    name: "药士",
    value: "10",
  },
  {
    name: "主任护师",
    value: "11",
  },
  {
    name: "副主任护师",
    value: "12",
  },
  {
    name: "主管护师",
    value: "13",
  },
  {
    name: "护师",
    value: "14",
  },
  {
    name: "护士",
    value: "15",
  },
  {
    name: "主任技师",
    value: "16",
  },
  {
    name: "副主任技师",
    value: "17",
  },
  {
    name: "主管技师",
    value: "18",
  },
  {
    name: "技师",
    value: "19",
  },
  {
    name: "技士",
    value: "20",
  },
  {
    name: "其他",
    value: "21",
  },
];
// 学科字典
export const subjectDic = [
  {
    title: "中医",
    value: 1,
    disabled: true,
    children: [
      {
        title: "中医内科",
        value: 3,
      },
      {
        title: "中医外科",
        value: 4,
      },
      {
        title: "中医妇（儿）科",
        value: 5,
      },
      {
        title: "中医针灸科",
        value: 6,
      },
      {
        title: "中医推拿科",
        value: 7,
      },
      {
        title: "中医康复科",
        value: 8,
      },
      {
        title: "中医骨伤科",
        value: 9,
      },
      {
        title: "中医急诊科",
        value: 10,
      },
      {
        title: "中医感染性疾病科",
        value: 11,
      },
      {
        title: "中医治未病科",
        value: 12,
      },
      {
        title: "中医皮肤科",
        value: 13,
      },
      {
        title: "中医肛肠科",
        value: 14,
      },
      {
        title: "中医眼科",
        value: 15,
      },
      {
        title: "中医耳鼻咽喉科",
        value: 16,
      },
      {
        title: "中医老年病科",
        value: 17,
      },
      {
        title: "中医重症医学科",
        value: 18,
      },
      {
        title: "中医口腔科",
        value: 19,
      },
      {
        title: "中医全科",
        value: 20,
      },
      {
        title: "中医麻醉科",
        value: 21,
      },
      {
        title: "中医医学检验科",
        value: 22,
      },
      {
        title: "中医医学影像科",
        value: 23,
      },
      {
        title: "中医消毒供应室",
        value: 24,
      },
      {
        title: "中医药剂科",
        value: 25,
      },
      {
        title: "中医输血科",
        value: 26,
      },
      {
        title: "中医其他",
        value: 27,
      },
    ],
  },
  {
    title: "西医",
    value: 2,
    disabled: true,
    children: [
      {
        title: "内科",
        value: 28,
      },
      {
        title: "外科",
        value: 29,
      },
      {
        title: "妇产科",
        value: 30,
      },
      {
        title: "儿科",
        value: 31,
      },
      {
        title: "眼科",
        value: 32,
      },
      {
        title: "耳鼻喉科",
        value: 33,
      },
      {
        title: "口腔科",
        value: 34,
      },
      {
        title: "老年病科",
        value: 35,
      },
      {
        title: "皮肤科",
        value: 36,
      },
      {
        title: "精神科",
        value: 37,
      },
      {
        title: "感染性疾病科",
        value: 38,
      },
      {
        title: "急诊医学科",
        value: 39,
      },
      {
        title: "麻醉科",
        value: 40,
      },
      {
        title: "重症医学科",
        value: 41,
      },
      {
        title: "康复医学科",
        value: 42,
      },
      {
        title: "中医科",
        value: 43,
      },
      {
        title: "全科",
        value: 44,
      },
      {
        title: "医学检验科",
        value: 45,
      },
      {
        title: "医学影像科",
        value: 46,
      },
      {
        title: "病理科",
        value: 47,
      },
      {
        title: "药剂科",
        value: 48,
      },
      {
        title: "临床营养科",
        value: 49,
      },
      {
        title: "输血科",
        value: 50,
      },
      {
        title: "其他",
        value: 51,
      },
    ],
  },
];
// 根据入口不同展示不同的注册信息文本
export const registerTextFromWhere = new Map([
  ["banner", "请在下方输入手机号报名参会"],
  ["register", "请输入注册手机号"],
  ["login", "登录"],
]);
export const confirmUserInfoTitle = new Map([
  ["banner", "请补全报名信息"],
  ["register", "参加培训学习（会议直播、在线学习）需完善信息"],
  ["login", "参加培训学习（会议直播、在线学习）需完善信息"],
]);
// 根据入口不同展示不同的注册提示信息
export const registerSuccessText = new Map([
  ["banner", "报名成功"],
  ["register", "注册成功，请登录。您的用户名为手机号，密码为手机号后六位。"],
  ["login", "登录成功"],
]);
// 根据入口不同展示不同的注册提示信息
export const confirmSubmitText = new Map([
  ["banner", "确认报名"],
  ["register", "确认注册"],
  ["login", "确认提交"],
]);
